<template>
    <div class="info-box">
        <div class="mx-4 py-3 d-flex flex-row">
            <span class="ms-2 me-3">
                <info_icon_blau></info_icon_blau>
            </span>
            <div>
                <b>Für die Beitragsberechnung benötigen wir das Geburtsdatum der ältesten im Haushalt lebenden Person.</b>
            </div>
        </div>
    </div>
</template>

<script setup>
import info_icon_blau from '@/components/icons/info_icon_blau.vue';
</script>